import { render, staticRenderFns } from "./TermicCourseStudentList.vue?vue&type=template&id=5720888f"
import script from "./TermicCourseStudentList.vue?vue&type=script&lang=js"
export * from "./TermicCourseStudentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports